import * as React from 'react';
import { Grid, Select, SelectChangeEvent, Tooltip } from '@mui/material';
import { FilterContainer, FilterInput, FilterItem, Label, FilterFormControl, StyledMenuItem, FilterListItemText } from '../styledComponents';
import { BaseFilter } from './baseFilter';
import { useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMoreRounded";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import { todoService, TodoItem } from '../../services/todoService';
import { colors } from '../../constants/colors';
import { usePrevious } from '../../hooks/usePrevious';

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 400,
            width: 250,
        },
    },
};

interface TodoFilterProps {
    onEnter: any;
    filters: any;
    setFiltersState: any;
}

const ToDoFilter: React.FunctionComponent<TodoFilterProps> = ({ onEnter, filters, setFiltersState }) => {
    const [todoItems, setTodoItems] = useState<TodoItem[]>([]);

    const handleChangeTodoByNames = (event: SelectChangeEvent<string[]>) => {
        const val = event.target.value as string[];
        console.log('Todo filter: Selected todos:', val);
        setFiltersState({ todoByNames: val });
    };

    useEffect(() => {
        const fetchTodoItems = async () => {
            try {
                const items = await todoService.getTodoItems();
                setTodoItems(items);
            } catch (error) {
                console.error('Error fetching todo items:', error);
            }
        };
        
        fetchTodoItems();
    }, []);

    const prevTodoByNames = usePrevious(filters.todoByNames?.length) || 0;

    useEffect(() => {
        if (
            prevTodoByNames !== (filters.todoByNames?.length || 0)
        ) {
            console.log('Todo filter: Calling onEnter with todos:', filters.todoByNames);
            onEnter();
        }
    }, [
        prevTodoByNames,
        filters.todoByNames,
        onEnter
    ]);

    return (
        <BaseFilter title="Todos">
            <Grid container direction="column" justifyContent="space-between">
                <FilterContainer container direction="row" justifyContent="space-between">
                    <FilterItem item>
                        <Label>Min Todos</Label>
                        <FilterInput
                            id="minTodos"
                            InputProps={{
                                sx: { height: 30 }
                            }}
                            placeholder="0"
                            variant="outlined"
                            value={filters.minTodos || ''}
                            onChange={e => setFiltersState({ minTodos: e.target.value.length === 0 ? null : parseFloat(e.target.value) })}
                            onKeyPress={ev => onEnter(ev)}
                            type="number"
                        />
                    </FilterItem>
                    <FilterItem item>
                        <Label>Max Todos</Label>
                        <FilterInput
                            id="maxTodos"
                            InputProps={{
                                sx: { height: 30 }
                            }}
                            placeholder="25"
                            variant="outlined"
                            value={filters.maxTodos || ''}
                            onChange={e => setFiltersState({ maxTodos: e.target.value.length === 0 ? null : parseFloat(e.target.value) })}
                            onKeyPress={ev => onEnter(ev)}
                            type="number"
                        />
                    </FilterItem>
                </FilterContainer>
                <Label>Select Todo(s) by Name</Label>
                <FilterContainer>
                    <FilterFormControl variant="outlined">
                        <InputLabel id="todo-by-names-label">Select Todo(s)</InputLabel>
                        <Select
                            id="todo-by-names-select"
                            multiple
                            sx={{
                                height: 48 
                            }}
                            variant={'outlined'}
                            size="small"
                            value={filters.todoByNames || []}
                            onChange={handleChangeTodoByNames}
                            input={<Input/>}
                            MenuProps={MenuProps}
                            IconComponent={ExpandMoreIcon}
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return "All Todos";
                                } else if (selected.length === 1) {
                                    return selected[0];
                                } else {
                                    return `${selected.length} Todos Selected`;
                                }
                            }}
                        >
                            {todoItems.map(todoItem => (
                                <Tooltip 
                                    key={todoItem.id}
                                    title={todoItem.name}
                                    placement="left"
                                    arrow
                                >
                                    <StyledMenuItem value={todoItem.name}>
                                        <Checkbox
                                            checked={(filters.todoByNames || []).indexOf(todoItem.name) > -1}
                                            color="primary"
                                            style={{ color: colors.blue1 }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                const currentTodos = filters.todoByNames || [];
                                                const todoName = todoItem.name;
                                                let newTodos;
                                                
                                                if (currentTodos.includes(todoName)) {
                                                    newTodos = currentTodos.filter((name: string) => name !== todoName);
                                                } else {
                                                    newTodos = [...currentTodos, todoName];
                                                }
                                                
                                                console.log('Todo checkbox clicked:', todoName, 'New todos:', newTodos);
                                                setFiltersState({ todoByNames: newTodos });
                                            }}
                                        />
                                        <ListItemText 
                                            primary={todoItem.name} 
                                            primaryTypographyProps={{ 
                                                sx: { 
                                                    whiteSpace: 'nowrap', 
                                                    overflow: 'hidden', 
                                                    textOverflow: 'ellipsis',
                                                    color: colors.blue2 
                                                } 
                                            }}
                                        />
                                    </StyledMenuItem>
                                </Tooltip>
                            ))}
                        </Select>
                    </FilterFormControl>
                </FilterContainer>
            </Grid>
        </BaseFilter>
    );
};

export { ToDoFilter };
